<template>
  <div class="outer-wrapper">
    <van-tabs v-model="currentTab" @change="tabClick">
      <van-tab title="add">
        <template #title> 新增包裹 </template>
        <div style="padding-top: 2rem">
          <van-panel title="上传图片：" desc status>
            <div class="d-wrapper">
              <van-uploader
                :after-read="handleAfterRead"
                deletable
                v-model="imgList"
                capture="camera"
              />
            </div>
          </van-panel>
          <van-field
            v-model="receivedPackage.delivery_no"
            label="快递单号"
            maxlength="30"
            placeholder="请输入部分或全部快递单号"
          />
          <van-field
            v-model="receivedPackage.addressee"
            label="收件人"
            maxlength="10"
            placeholder="请输入快递信息上的收件人"
          />
          <van-field
            v-model="receivedPackage.remark"
            rows="2"
            autosize
            label="备注"
            type="textarea"
            maxlength="50"
            placeholder="请输入备注信息"
            show-word-limit
          />
          <div class="button-wrapper">
            <van-button
              color="#ee0a24"
              style="width: 4rem"
              @click="checkSubmit"
              :disabled="!submitAbled"
              >提交</van-button
            >
            <van-button
              color="#ee0a24"
              plain
              style="width: 4rem; margin-left: 1rem"
              @click="reSet"
              >取消</van-button
            >
          </div>
        </div>
      </van-tab>
      <van-tab title="cl">
        <template #title>已接受包裹 </template>
        <div class="editor-wrapper">
          <p class="date-filter">
            <span
              class="last-day-span"
              @click="dateChange(-1)"
              v-show="currentDate"
              >上一天</span
            ><span @click="showCalendar">{{
              currentDate ? currentDateStr : "筛选日期"
            }}</span>
            <span
              style="margin-left: 0.3rem"
              @click="delDate"
              v-show="currentDate"
            >
              <van-icon name="cross" />
            </span>
            <van-calendar v-model="calendarSw" @confirm="onConfirmCalendar" />
            <span
              class="next-day-span"
              @click="dateChange(1)"
              v-show="currentDate"
              >下一天</span
            >
          </p>
          <div v-if="table.tivdata.length > 0">
            <van-list
              v-model="table.loading"
              :finished="table.finished"
              finished-text="没有更多了"
              :error.sync="table.error"
              error-text="请求失败，点击重新加载"
              @load="onLoad"
            >
              <template v-for="(item, index) in table.tivdata"
                ><van-cell :key="index + 'p'" :title="dayFormat(item.op_time)">
                  <span class="cell-item">{{
                    "共" + item.imgList.length + "张"
                  }}</span>
                  <template #right-icon>
                    <van-icon
                      name="delete-o"
                      class="icon-s"
                      @click="delPackage(item)"
                    />
                  </template>
                </van-cell>
                <img-slide
                  :imgList="item.imgList.map((val) => val.static_url)"
                  height="3rem"
                  :key="index + 's'"
                  @click.native="preview(item.imgList)"
                >
                </img-slide>
                <p :key="index + 'pp'" class="des-p" >
                  <span class="des-label">快递单号：</span>
                  {{ item.delivery_no }}</p>
                <p :key="index + 'pp1'" class="des-p" >
                  <span class="des-label">收件人：</span>
                  {{ item.addressee }}</p>
                <p :key="index + 'pp4'" class="des-p"><span class="des-label">当前库位：</span>{{ item.warehouse_display_no?item.warehouse_display_no:'尚未入库' }}</p>
                <p :key="index + 'pp2'" class="des-p" ><span class="des-label">备注：</span>{{ item.remark }}</p>
                <p :key="index+'pp3'" class="remark-p"><van-button type="info" size="small" style="width:5rem;" @click="takeP(item.enid)">查看详情</van-button></p>
              </template>
            </van-list>
          </div>
          <van-empty description="" v-else />
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>
<script>
import dayjs from "dayjs";
import { ImagePreview } from "vant";
import imgSlide from "@/components/Common/ImgSlide.vue";
let userToken = localStorage.getItem("current_user_token");
let authData = JSON.parse(localStorage.getItem("authData"));
import { textTrans } from "@/mixins/TextTrans.js";

function tableFac() {
  return {
    loading: false,
    finished: false,
    error: false,
    Tpage: {
      currentPage: 1,
      currentSize: 20,
    },
    no_data_text: "",
    totalItems: 0,
    tivdata: [
      /*{
            op_time: null,
            operator:"",
            operator_name:"",
            remark:"",
            imgList:[]
          }*/
    ],
  };
}

function packageFac(){
  return {
    delivery_no:'',
    addressee:'',
    remark:''
  };
}

export default {
  name: "packageManage",
  components: {
    imgSlide,
  },
  mixins: [textTrans],
  data() {
    return {
      currentTab: "add",
      receivedPackage: packageFac(),
      currentDate: null,
      calendarSw: false,
      table: tableFac(),
      sampleShow: false,
      imgList: [],
    };
  },
  watch: {},
  computed: {
    submitAbled: function () {
      if (this.imgList.length>0) {
        return true;
      } else {
        return false;
      }
    },
    currentDateStr() {
      if (this.currentDate) {
        return dayjs(this.currentDate).format("YYYY-MM-DD");
      } else {
        return "";
      }
    },
  },
  created() {},
  methods: {
    onSearch() {
      this.table.tivdata = [];
      this.table.Tpage.currentPage = 1;
      this.table.Tpage.currentSize = 20;
      this.table.finished = false;
      this.onLoad();
    },
    onLoad() {
      this.table.loading = true;
      this.$axios
        .post(this.$url + "/ask_list_data", {
          page: this.table.Tpage,
          userToken: userToken,
          ask_data: "packageManageList",
          currentDate: this.currentDateStr,
        })
        .then((response) => {
          for (let ele of response.data.res_record) {
            for (let item of ele.imgList) {
              item.static_url = this.$fileUrlFac(
                item.img_url,
                authData.sfileRight
              );
            }
            this.table.tivdata.push(ele);
          }
          // this.table.tivdata.push({
          //   op_time: new Date(),
          //   operator: "张三",
          //   operator_name: "张三",
          //   remark: "",
          //   imgList: [
          //     { static_url: "https://img01.yzcdn.cn/vant/cat.jpeg" },
          //     { static_url: "https://img01.yzcdn.cn/vant/cat.jpeg" },
          //     { static_url: "https://img01.yzcdn.cn/vant/cat.jpeg" },
          //     { static_url: "https://img01.yzcdn.cn/vant/cat.jpeg" },
          //     { static_url: "https://img01.yzcdn.cn/vant/cat.jpeg" },
          //   ],
          // });
          if (response.data.res_record.length < this.table.Tpage.currentSize) {
            this.table.finished = true;
          }
          this.table.loading = false;
          this.table.Tpage.currentPage++;
        });
    },
    reSet() {
      this.imgList = [];
      this.receivedPackage = packageFac();
    },
    checkSubmit() {
      if (this.submitAbled) {
        let form = new FormData();
        form.append("userToken", userToken);
        form.append("receivedPackage", JSON.stringify(this.receivedPackage));
        form.append("askData", "newPackage");
        for (let img of this.imgList) {
          if (img.obj !== undefined) {
            form.append("packageImg", img.obj);
          }
        }
        let config = {
          headers: { "Content-Type": "multipart/form-data" },
        };
        this.$axios
          .post(this.$url + "/update_package", form, config)
          .then((response) => {
            if (response.data.stat === "ok") {
              this.$toast.success("包裹信息上传成功！");
              this.reSet();
            } else {
              this.$toast.fail(response.data.error_info);
            }
          })
          .catch((error) => {
            this.$toast.fail(error + "网络连接失败！");
          });
      }
    },
    handleAfterRead(img, detail) {
      if (img.file.size < 1024 * 200) {
        this.imgList[detail.index].obj = img.file;
      } else {
        let vm = this;
        var reader = new FileReader();
        reader.readAsDataURL(img.file);
        reader.onload = function (e) {
          let img = new Image();
          img.src = e.target.result;
          img.onload = function () {
            let width = 800, //图像大小
              quality = 0.7, //图像质量
              canvas = document.createElement("canvas"),
              drawer = canvas.getContext("2d");
            canvas.width = width;
            canvas.height = width * (img.height / img.width);
            drawer.drawImage(img, 0, 0, canvas.width, canvas.height);
            vm.imgList[detail.index].url = canvas.toDataURL(
              "image/jpeg",
              quality
            );
            vm.imgList[detail.index].obj = vm.convertBase64UrlToFile(
              vm.imgList[detail.index].url,
              "img" + detail.index + ".jpeg"
            );
            this.imgAlter = true;
          };
        };
      }
    },
    // handleBeforeDelete(img) {
    //   if (img.url !== undefined) {
    //     this.imgDeleted.push(img.url);
    //   } else {
    //     if (this.imgList.findIndex((val) => val.obj !== undefined) === -1) {
    //       this.imgAlter = false;
    //     }
    //   }
    //   return true;
    // },
    convertBase64UrlToFile(urlData, filename) {
      let arr = urlData.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    showCalendar() {
      this.calendarSw = true;
    },
    onConfirmCalendar(date) {
      this.calendarSw = false;
      this.currentDate = date;
      this.onSearch();
    },
    delDate() {
      this.currentDate = null;
      this.onSearch();
    },
    dateChange(delta) {
      if (this.currentDate) {
        let tmp = dayjs(this.currentDate);
        if (delta > 0) {
          this.$set(this, "currentDate", tmp.add(delta, "day").toDate());
        } else if (delta < 0) {
          this.$set(this, "currentDate", tmp.subtract(-delta, "day").toDate());
        }
        this.onSearch();
      }
    },
    dayFormat(value) {
      return dayjs(value).format("YYYY-MM-DD");
    },
    preview(item) {
      ImagePreview({ images: item.map((val) => val.static_url) });
    },
    tabClick(name, title) {
      if (title === "cl") {
        this.onSearch();
      }
    },
    delPackage(item) {
      this.$dialog
        .confirm({
          title: "确定删除该条包裹记录？",
          message: "",
        })
        .then(() => {
          let form = new FormData();
          form.append("userToken", userToken);
          form.append("pid", item.id);
          form.append("askData", "delPackage");
          let config = {
            headers: { "Content-Type": "multipart/form-data" },
          };
          this.$axios
            .post(this.$url + "/update_package", form, config)
            .then((response) => {
              if (response.data.stat === "ok") {
                this.onSearch();
              } else {
                this.$toast.fail(response.data.error_info);
              }
            })
            .catch((error) => {
              this.$toast.fail(error + "网络连接失败！");
            });
        })
        .catch(() => {});
    },
    takeP(enid){
      location.href="/packageOp/"+enid;
    }
  },
};
</script>
<style scoped>
.inner-wrapper {
  width: 100%;
  background: #f7f7f7;
  min-height: 20rem;
}

.title-wrapper {
  text-align: center;
  font-size: 0.8rem;
  color: #999;
  padding: 1rem;
  background: #fff;
  border-bottom: 1px solid #f6f6f6;
}

.editor-wrapper {
  width: 100%;
}
.cell-item {
  margin-right: 0.6rem;
}

.op {
  outline: none;
  border: 1px solid #eee;
  color: #fff;
  background: rgb(11, 155, 18);
  font-weight: 400;
  height: 1rem;
  position: relative;
  top: 0.05rem;
  padding: 0.15rem 0.5rem;
  border-radius: 0.2rem;
}
.deny {
  background: rgb(228, 46, 14);
  margin-left: 0.5rem;
}

.text-wrapper {
  padding: 0.1rem 0.5rem;
}
.text-wrapper-con {
  padding: 1rem 0 1rem 2rem;
}

.textarea {
  width: 100%;
  height: 7rem;
}
.bold-text {
  font-weight: 600;
  color: #666;
}
.d-wrapper {
  padding: 0.5rem 1rem;
  text-align: center;
  font-size: 0.6rem;
}
.button-wrapper {
  padding: 2rem;
  text-align: center;
}
.radio-item {
  margin-top: 1rem;
  margin-left: 30%;
}

.date-filter {
  text-align: center;
  position: relative;
  font-size: 0.6rem;
  color: #666;
  padding: 0.8rem 0.2rem;
}

.last-day-span {
  position: absolute;
  left: 1rem;
  color: blue;
}

.next-day-span {
  position: absolute;
  right: 1rem;
  color: blue;
}

.icon-s {
  position: relative;
  top: 0.2rem;
}

.remark-p {
  border-top: 1px solid #eee;
  border-bottom: 3px double #ddd;
  padding: 0 0.3rem;
  text-align: right;
}

.des-p{
  padding: 0.5rem 0.8rem;
  font-size: 0.8rem;
  color: #333;
  border-top: 1px solid #eee;

}

.des-label{
  font-size:0.6rem;
  color:#999;
}
</style>